module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/cPeUMn/tc-custom/9781935753742.jpg?1723407763109",
      "alt": "This image is the cover for the book Santa, Actually"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Santa, Actually\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Sequel to That's Entertainment!")]), _c('br'), _c('br'), _vm._v("The cast and crew of WrinkleTheSheets Productions are back with a special seasonal production. As Gerry, the Director says, “Santa thinks he needs more positive PR this year. His market share has been seriously threatened by Amazon. No one uses him for a wishlist any more. He’s in trouble, and needs to re-establish himself with his adult clientele, so he’s on the lookout for a special gift. Something fresh, something marketable, something "), _c('i', [_vm._v("hot")]), _vm._v(". This is just a short promo for the client, okay? Some fun with the elves, an X-rated update on the fat old man with the beard. Snow, sleigh bells, reindeer, plenty of bling.”"), _c('br'), _c('br'), _vm._v("The official stars are the diva Quinn and the sharp-tongued Tomasz, plus Tomasz’s new squeeze. But Jack and Grady are a constant presence. They continue on their merry way, engrossed in each other, in having fun and sex -- and usually both together -- and happy to be nothing more than extras in the movies."), _c('br'), _c('br'), _vm._v("But this season, the mystery client appears to have rewritten the script for them!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Clare London\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0